import { Component } from "react";
import { formatDate } from "../../common/services/utilities";
import ThemeableAgGrid from "../../common/components/agGrid/ThemeableAgGrid";
import { withTranslation } from "react-i18next";

class BCEnvironmentalRegistryTable extends Component {
  // Define column definitions using the getColumnDefs method
  getColumnDefs() {
    return [
      {
        field: "ProjectName",
        headerName: this.props.t("ProjectName"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "AccountName",
        headerName: this.props.t("AccountName"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "Location",
        headerName: this.props.t("Location"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "Quantity",
        headerName: this.props.t("Quantity"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "StandardName",
        headerName: this.props.t("StandardName"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "Vintage",
        headerName: this.props.t("Vintage"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "ProjectType",
        headerName: this.props.t("ProjectType"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "MonitoringPeriodStart",
        headerName: this.props.t("MonitoringPeriodStart"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "MonitoringPeriodEnd",
        headerName: this.props.t("MonitoringPeriodEnd"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "Status",
        headerName: this.props.t("Status"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "VerifierCompany",
        headerName: this.props.t("VerifierCompany"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "SerialNo",
        headerName: this.props.t("SerialNo"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "UnitType",
        headerName: this.props.t("UnitType"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "UnitMeasurementName",
        headerName: this.props.t("UnitMeasurementName"),
        filter: false,
        floatingFilter: false,
      },
    ];
  }

  mapToViewModel(registry) {
    return registry.map((record, index) => ({
      index: index,
      ProjectName: record.projectName,
      AccountName: record.accountName,
      Location: record.location,
      Quantity: record.holdingQuantity,
      StandardName: record.standardName,
      Vintage: record.vintage,
      ProjectType: record.projectType,
      MonitoringPeriodStart: record.monitoringPeriodStart
        ? formatDate(record.monitoringPeriodStart)
        : null,
      MonitoringPeriodEnd: record.monitoringPeriodEnd
        ? formatDate(record.monitoringPeriodEnd)
        : null,
      Status: record.status,
      VerifierCompany: record.verifierName,
      SerialNo: record.serialNo,
      UnitType: record.unitType,
      UnitMeasurementName: record.unitMeasurementName,
    }));
  }

  render() {
    const { registry, onRowClick } = this.props;

    const mappedRegistry = this.mapToViewModel(registry);
    const columnDefs = this.getColumnDefs();

    // Pagination configuration
    const paginationConfig = {
      // Enable pagination for all tables regardless of size
      enabled: true,
      // Default page size
      pageSize: 20,
      // Available page size options for user to choose
      pageSizeOptions: [5, 10, 20, 50, 100],
    };

    return (
      <ThemeableAgGrid
        className="table-extra-small"
        columnDefs={columnDefs}
        rowData={mappedRegistry}
        onRowClicked={(params) => onRowClick && onRowClick(params.data)}
        getRowId={(params) => String(params.data.index)}
        pagination={true}
        paginationPageSize={paginationConfig.pageSize}
        paginationPageSizeSelector={paginationConfig.pageSizeOptions}
        suppressPaginationPanel={false}
        allowHorizontalScroll={false}
      />
    );
  }
}

export default withTranslation(["marketdata"])(BCEnvironmentalRegistryTable);
